import { EFetchMapDataActionType } from '../../../Map/actions';
import { TReduxActions } from '../../actions';
import { EMapBoundsActionType } from '../../actions/mapBounds';
import { toListingUrl } from '../../mappers/queryString';
import { UrlWithBoundsBuilder } from '../../utils/urlWithBoundsBuilder';

export function listingUrlReducer(state: string = '#', action: TReduxActions): string {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed:
      if (action.payload.clean) {
        return toListingUrl(action.payload.queryString);
      }

      return state;
    case EMapBoundsActionType.Changed:
      return new UrlWithBoundsBuilder(state, action.payload).withCenter().withZoom().withBbox().build();
    default:
      return state;
  }
}
